module.exports = __webpack_public_path__ + "static/img/card_5_2.e4a78e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/es/card_5_2.png
// module id = QY4+
// module chunks = 0